// Components
import { AntSwitch, AntSwitchBorderedControlLabel, CustomFormLabel, CustomTextField } from '../../../../pages/styles'

// Styles
import { ContainerInput, ContainerGroup, ContainerContent, ContainerBox, TextSwitch } from './styles'

// Utils
import { useTranslation } from 'react-i18next'

export const Company = ({
    isNew, form, errors, disabled, handleChange, handleState
}) => {
    const { t } = useTranslation();

    return (
        <ContainerBox>
            <ContainerContent>

                <ContainerGroup isFirsts>
                    <ContainerInput>
                        <CustomFormLabel>{t('company.table.nit')}:</CustomFormLabel>
                        <CustomTextField
                            type='number'
                            value={form.nit}
                            size="small"
                            onChange={e => handleChange(e, 'nit')}
                            onKeyDown={(e) => {
                                if (['-', '.', ','].includes(e.key)) {
                                    e.preventDefault();
                                }
                            }}
                            error={!(!errors?.nit.error)}
                            helperText={errors?.nit.error}
                            style={{ width: '100%' }}
                            disabled={disabled}
                            required
                        />
                    </ContainerInput>

                    <ContainerInput>
                        <CustomFormLabel>{t('company.table.dv')}:</CustomFormLabel>
                        <CustomTextField
                            type='number'
                            value={form.dv}
                            size="small"
                            onChange={e => handleChange(e, 'dv', 3)}
                            onKeyDown={(e) => {
                                if (['-', '.', ','].includes(e.key)) {
                                    e.preventDefault();
                                }
                            }}
                            error={!(!errors?.dv.error)}
                            helperText={errors?.dv.error}
                            style={{ width: '100%' }}
                            disabled={disabled}
                            required
                        />
                    </ContainerInput>

                    {!isNew && 
                    <ContainerInput sx={{ width: '30%' }}>
                        <CustomFormLabel>&nbsp;</CustomFormLabel>
                        <AntSwitchBorderedControlLabel
                            disabled={disabled}
                            control={
                                <AntSwitch
                                    checked={form.isActive}
                                    onChange={() => handleState(!form.isActive)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                            }
                            label={
                                <TextSwitch enabled={form.isActive}>{form.isActive ? t('system.active') : t('system.inactive')}</TextSwitch>
                            } 
                        />
					</ContainerInput>
                    }
                    
                </ContainerGroup>
                <ContainerGroup sx={{ mt: 2 }}>
                    <ContainerInput isFull>
                        <CustomFormLabel>{t('company.table.name')}:</CustomFormLabel>
                        <CustomTextField
                            value={form.name}
                            size="small"
                            onChange={e => handleChange(e, 'name')}
                            error={!(!errors?.name.error)}
                            helperText={errors?.name.error}
                            style={{ width: '100%' }}
                            disabled={disabled}
                            required
                        />
                    </ContainerInput>
                </ContainerGroup>

            </ContainerContent>
        </ContainerBox>
    )
}